const ToggleAnimate = require('../../velocity/toggle-animate');
const { getIndex } = require('../../module/index');

/**
 * Nav
 * @class
 */
class Nav {

  /**
   * @static
   */
  get elms() {
    return {
      listClass: 'js-nav-list',
      cntClass : 'js-nav-cnt',
    }
  }

  /**
   * @param _$el {HTMLElement}
   */
  constructor(_$el) {
    this.$$list = _$el.getElementsByClassName(this.elms.listClass);
    this.$$cnt  = _$el.getElementsByClassName(this.elms.cntClass);

    this.toggleCnt = new ToggleAnimate({
      anime: [{
        opacity: [ 1, 'linear', 0 ],
        rotateX: [ 0, 'easeOutCubic', -30 ],
      }, {
        opacity: [ 0, 'linear' ],
        rotateX: [ -30, 'easeOutCubic' ],
      }],
      opts : {
        duration: 300,
      }
    });

    _.forEach(this.$$list, (_$el) => {
      _$el.addEventListener('mouseenter', this.show.bind(this));
      _$el.addEventListener('mouseleave', this.hide.bind(this));
    });
  }

  /**
   * @private
   * @param _e {event}
   */
  show(_e) {
    const index_ = getIndex(_e.currentTarget, this.$$list);

    this.toggleCnt.run(true, { $el: this.$$cnt[index_] });
  }

  /**
   * @private
   * @param _e {event}
   */
  hide(_e) {
    const index_ = getIndex(_e.currentTarget, this.$$list);

    this.toggleCnt.run(false, { $el: this.$$cnt[index_] });
  }

}

module.exports = Nav;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/pc/ui/nav.js
 **/